import React from 'react'
import { useCountryList } from '@mobi/account/Areas/Verification/Hooks'
import {
  AlphabeticalCountryList,
  PopularCountryList,
} from '@mobi/account/Common/CountryOptionGroups'
import { OptionStyled, SelectField, SelectFieldProps } from '@mobi/component-library/Legacy/Select'

export const CountrySelect = ({ ...props }: SelectFieldProps) => {
  const { isLoading, isError, data: countries } = useCountryList()

  return (
    <SelectField {...props}>
      {isLoading && <OptionStyled value=''>Loading ...</OptionStyled>}

      {isError && <OptionStyled value=''>Could not load countries</OptionStyled>}

      {!isLoading && !isError && countries && (
        <>
          <OptionStyled value=''>Select a country</OptionStyled>
          <PopularCountryList countries={countries} />
          <AlphabeticalCountryList countries={countries} />
        </>
      )}
    </SelectField>
  )
}
